import RemoteSelect from "common/components/RemoteSelect/RemoteSelect";
import { User } from "types";
import usePark from "common/hooks/usePark";
import useAuth from "common/hooks/useAuth";
import { useTranslation } from "react-i18next";
import { useCallback } from "react";

function UserSelect(props: any) {
  const { park } = usePark();

  const { user } = useAuth();
  const { t } = useTranslation();

  const processOptions = useCallback(
    (options: User[]) => {
      const meIndex = options.findIndex((option) => option.id === user?.id);

      const list = options.map(({ id, username }) => ({
        value: id,
        label: username,
      }));

      if (meIndex === -1) {
        return list;
      }

      const userToMove = list[meIndex];
      userToMove.label = `${userToMove.label} (${t("forms.me")})`;
      list.splice(meIndex, 1); // Supprime l'utilisateur de son emplacement actuel
      list.unshift(userToMove); // Ajoute l'utilisateur au début du tableau

      return list;
    },
    [user, t]
  );

  return (
    <RemoteSelect
      url="users"
      processOptions={processOptions}
      filters={
        props.noPublicUsers
          ? [
              { name: "park][id", value: park?.id },
              { name: "role][name][$ne", value: "Authenticated" },
            ]
          : [{ name: "park][id", value: park?.id }]
      }
      sorts={["name:ASC"]}
      {...props}
    />
  );
}

export default UserSelect;
